import { mapValue, renderStat } from '@utils/formatStat'
import capitalize from '@utils/capitalize'
import { size } from '@styles/theme'

import { DialogFormGroup, Section, SectionHeading } from './SharedFormComponents'
import { EnumValueCheckbox } from '@elements/form_elements/EnumValueCheckbox'
import { DialogInput } from '@elements/dialog_inputs/DialogInput'
import { PiInfoBold } from 'react-icons/pi'

const labelStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexShrink: 0,
  width: size(15),
  marginRight: size(-4),
}

const longLabelStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexShrink: 0,
  width: size(20),
  marginRight: size(-4),
}

const HostLocationCheckList = ({ state, handleEnumChange }) => {
  const vals = ['can_host', 'can_travel']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: labelStyles } }}
          state={state}
          property='hostLocation'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const SexuallyIntoCheckList = ({ state, handleEnumChange }) => {
  const vals = ['ball_play', 'cuddling', 'docking', 'fingering', 'fisting', 'frotting', 'fucking', 'jerk_off', 'kissing', 'massage', 'oral', 'oral_give_only', 'oral_receive_only', 'rimming']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: longLabelStyles } }}
          state={state}
          property='sexuallyInto'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const LookingForCheckList = ({ state, handleEnumChange }) => {
  const vals = ['bear', 'bro', 'clean_cut', 'college', 'corporate', 'cub', 'curious', 'daddy', 'discreet', 'drag', 'emo', 'fairie', 'femme', 'female_to_male', 'gaymer', 'geek', 'goth', 'guy_next_door', 'intellectual', 'intersex', 'jock', 'leather', 'masc', 'male_to_female', 'nudist', 'otter', 'poz', 'punk', 'pup', 'rugged', 'skater', 'son', 'sporty', 'swinger', 'trans', 'trucker', 'twink', 'uniformed', 'u_plus', 'wolf']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: labelStyles } }}
          state={state}
          property='lookingFor'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const KinksCheckList = ({ state, handleEnumChange }) => {
  const vals = ['bdsm', 'bondage', 'chastity', 'cum_play', 'drag', 'edging', 'exhibitionism', 'facials', 'fisting', 'fleshlights', 'gags_and_tape', 'gloryholes', 'group_sex', 'humiliation', 'photos_videos', 'porn', 'toys', 'dolls', 'shaving', 'sniffing', 'spanking', 'voyeurism', 'watersports', 'flogging']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: labelStyles } }}
          state={state}
          property='kinks'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const RolesSituationsCheckList = ({ state, handleEnumChange }) => {
  const vals = ['age_play', 'classroom', 'costume_play', 'cucking', 'delivery_guy', 'doctor_patient', 'first_time', 'furries', 'handy_man', 'military', 'public_locker_rooms', 'public_nudity', 'public_restrooms', 'public_showers', 'pup_play', 'slave_master', 'sleep_play', 'slumber_party', 'superhero']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: longLabelStyles } }}
          state={state}
          property='rolesSituations'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const InteractionsCheckList = ({ state, handleEnumChange }) => {
  const vals = ['anonymous', 'blindfolded', 'bukkake', 'cum_and_go', 'dirty_talk', 'door_open', 'edging', 'eye_contact', 'flipping_swapping', 'gloryhole', 'jerk_together', 'no_reciprocation', 'mutual_play', 'pump_and_dump', 'rough_aggressive', 'understall', 'vanilla', 'watching', 'worship']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: longLabelStyles } }}
          state={state}
          property='interactions'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const FetishesCheckList = ({ state, handleEnumChange }) => {
  const vals = [
    // BODY OPTIONS
    'armpits', 'ass', 'bodyhair', 'bulges', 'hard_cocks', 'soft_cocks', 'hung_cocks', 'cum', 'facial_hair', 'feet', 'hands', 'happy_trails', 'long_hair', 'muscles', 'musk', 'nipples', 'pecs', 'piercings', 'bush', 'shaved', 'trimmed', 'spit', 'tattoos',
    // CLOTHING OPTIONS
    'baseball_caps', 'boots', 'denim', 'leather', 'lingirie', 'masks', 'gas_masks', 'mesh_nets', 'onesies', 'rubber', 'sagging', 'singlets', 'sneakers', 'socks', 'spandex_lycra', 'speedos', 'sports_gear', 'suits', 'uniforms', 'underwear', 'boxers', 'boxer_briefs', 'jockstraps', 'mesh', 'mormon_undergarments', 'nylons', 'panties', 'used_underwear', 'tighty_whities'
  ]
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: longLabelStyles } }}
          state={state}
          property='fetishes'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const SceneFormSection = ({ state, handleEnumChange, handleClear }) => {
  return (
    <Section style={{ paddingTop: size(2) }}>
      <SectionHeading>
        Scene
      </SectionHeading>
      <DialogInput
        label='Host Availability'
        onClear={() => handleClear('hostLocation', new Set())}
        displayValue={state['hostLocation'] && renderStat('hostLocation', state)}>
        <HostLocationCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Into'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('sexuallyInto', new Set())}
        displayValue={state['sexuallyInto'] && renderStat('sexuallyInto', state)}>
        <SexuallyIntoCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Looking For'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('lookingFor', new Set())}
        displayValue={state['lookingFor'] && renderStat('lookingFor', state)}>
        <LookingForCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Kinks'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('kinks', new Set())}
        displayValue={state['kinks'] && renderStat('kinks', state)}>
        <KinksCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Roles & Situations'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('rolesSituations', new Set())}
        displayValue={state['rolesSituations'] && renderStat('rolesSituations', state)}>
        <RolesSituationsCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Interactions'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('interactions', new Set())}
        displayValue={state['interactions'] && renderStat('interactions', state)}>
        <InteractionsCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Fetishes'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('fetishes', new Set())}
        displayValue={state['fetishes'] && renderStat('fetishes', state)}>
        <FetishesCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
    </Section>
  )
}

export { SceneFormSection }
